import Link from 'next/link'

import CircleCheck from 'components/icons/CircleCheck'
import { Button } from 'components/forms/Button'
import useWindowSize from 'components/util/useWindowSize'
import LeftRobotCard from 'components/cards/new/common/LeftRobotCard'

const features = [
  'Fully aligned with AU AML/CTF and KYC requirements',
  'Privacy practices meet OAIC standards',
  'Cyber Essentials Plus (UK) adapted to AU operations',
  'All SLAs, terms, and policy docs available upon request',
]

const SecurityAndCompliance = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm with mail envelope',
        desktop: {
          dimensions: {
            height: 820,
            width: 582,
          },
          src: '/images/new/au/robot-arm-mail-zoomed.png',
        },
        mobile: {
          dimensions: {
            height: 602,
            width: 361,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '36%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pb-lg-10 pe-lg-8 pt-lg-30 mt-lg-0 mt-n16'>
        <h2
          className='fw-semibold fs-fluid-48-80 lh-105'
          style={{
            maxWidth: 696,
          }}
        >
          Security & Compliance for{' '}
          <span className='color-pink2'>Australian</span> Partners
        </h2>
        <ul className='list-unstyled d-flex flex-column gap-4'>
          {features.map((feature, index) => (
            <li
              key={index}
              className='fs-fluid-18-26 fw-semibold lh-134 d-flex'
            >
              <CircleCheck
                fill='#30DB5B'
                className='me-2 mt-lg-2 flex-shrink-0 mt-1'
              />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <Link
          className='align-self-lg-end'
          href={'/au/enterprise#konnect-form'}
        >
          <Button className='w-100 w-lg-auto align-self-lg-end'>
            Book a Demo
          </Button>
        </Link>
      </div>
    </LeftRobotCard>
  )
}

export default SecurityAndCompliance
